module.exports = __webpack_public_path__ + "img/fruit-apples-190x100.226c839e.jpg";